import { render, staticRenderFns } from "./TkBadge.vue?vue&type=template&id=442b75ce&"
import script from "./TkBadge.vue?vue&type=script&lang=js&"
export * from "./TkBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports